exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-title[data-v-5699b9e2]{font-weight:600;text-decoration:none;color:#000!important}span[data-v-5699b9e2]{vertical-align:middle}.shopping-basket[data-v-5699b9e2]{float:left;text-decoration:none;color:#000!important}.version[data-v-5699b9e2]{float:right;font-size:10px;text-decoration:none;color:grey!important}.footer[data-v-5699b9e2]{padding-left:20px;padding-right:20px;position:fixed;bottom:0;width:100%;min-height:4em;background-color:#f0f0f0;height:100px;line-height:100px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5699b9e2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Footer.vue
// module id = 455
// module chunks = 0